import { packCardsPerPage } from 'constants/carousels';
import { PackCard, PackCardSkeleton } from 'components/Cards/PackCard';

export const PackCardConfig = {
    cardComponent: PackCard as any,
    fallbackComponent: PackCardSkeleton,
    slidesPerPage: packCardsPerPage,
    imageHeight: undefined,
};
